//#region react/redux
import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { withRouter } from "react-router"
//#endregion react/redux

//#region mui
import { withStyles } from "@mui/styles"
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBack"
//#endregion mui

import Box from '../ThemedBox'

import {
  AppBar,
  Button,
  CircularProgress,
  IconButton,
  styled,
  Toolbar,
  Tooltip,
  Typography,
} from '@mui/material'

import MuiTypography from '@mui/material/Typography'
import { Divider } from '@mui/material'

//#region  modules
import { actions as aiCostsActions } from "../../modules/aiCostsModule"
import { actions as appActions, selectors as appSelectors } from "../../modules/appModule"
import { actions as commonActions } from "../../modules/commonModule"
import { actions as lseActions } from "../../modules/lseModule"
import { actions as nexusActions } from "../../modules/nexusModule"
import { actions as newsActions } from "../../modules/newsModule"
import { actions as searchActions } from '../../modules/searchModule'
import { actions as synopsisActions } from "../../modules/synopsisModule"
import { selectors as userSelectors } from "../../modules/userModule"
import { BASE, COLOR, CONSTANTS, KEY_VALUES, LAYOUT, PATH, STATUS, TAB } from "../../modules/constants"
//#endregion  modules

import history from "../../services/history"
import numerableIcon from "../../assets/images/numerable_symbol_white_on_transparent_link.svg"
import numerableLogo from "../../assets/images/numerable-2022-logo-white-on-transparent-RGB.png"

import { HamburgerMenu } from "./HamburgerMenu"
import { DeveloperMenu } from "././DeveloperMenu"
import { UserMenu } from "./UserMenu"

const styles = () => ({
})

const handleOnClick = backLink => {
  backLink === true
    ? history.goBack()
    : history.push(backLink)
}

class DashboardNavbar extends Component {
  render() {
    // console.log('DashboardNavbar this.props:', this.props)

    const {
      activity,
      app,
      backLink,
      classes,
      currentUrl,
      email,
      features,
      isLoggedIn,
      name,
      network,
      nexus,
      page,
      portrait,
      scope,
      the350club,
      timeToLogout,
      standardTrialDaysLeft,
      urlTrial,
      urlTrialCode,
      urlTrialDaysLeft,
      version,
      synopsisData,
    } = this.props

    // console.log("trial days left=" + standardTrialDaysLeft)

    const infoItems = ["Subscribers can:",
      "* quickly research UK companies and their directors",
      "* save companies and people to favourites",
      "* configure news alert emails",
      "Click button for details"]
    const infoTip = infoItems.join('\n')
    const statusBackgroundColor = synopsisData?.overall === STATUS.GOOD
      ? COLOR.GOOD
      : synopsisData?.overall === STATUS.BAD
        ? COLOR.BAD
        : COLOR.WARN

    const NumerableLogo = styled('img')(({ theme }) => ({
      height: 24,
      marginLeft: LAYOUT.COLUMN_PADDING - 11,
      cursor: "pointer",
      "&:hover": {
        opacity: "50%",
      },
    }))

    return (
      <AppBar
        elevation={0}
      >
        <Toolbar variant="dense">

          {/* LEFT REGION *}

          {/* Numerable icon */}
          <Tooltip title={features.LseAppts ? "go to the Dashboard" : "go to Companies House tab"}>
            <IconButton onClick={() =>
            // window.open("https://www.numerable.io/?utm_source=numerable&utm_medium=numapp&utm_campaign=numlogo")}>
            {
              this.props.common.changeTab(
                {
                  ...this.props,
                  index: features.LseAppts ? TAB[BASE.DASHBOARD].INDEX : TAB[BASE.SEARCH].INDEX
                })
            }}>
              <NumerableLogo
                src={the350club || portrait ? numerableIcon : numerableLogo}
                alt={the350club || portrait ? "Numerable icon" : "Numerable logo"}
              />
            </IconButton>
          </Tooltip>

          {/* back arrow */}
          {backLink && (
            <Tooltip title="back to previous page">
              <IconButton id="backButton" className={classes.icon} aria-label="Open drawer" onClick={() => handleOnClick(backLink)}>
                <ArrowBackRoundedIcon fontSize="large" style={{ color: COLOR.NAVBAR_TEXT }} />
              </IconButton>
            </Tooltip>
          )}

          <Box variant="messages">

            {/* trial info */}
            {!the350club && urlTrialDaysLeft !== null &&
              <Typography variant="trial">
                {urlTrialDaysLeft > 1
                  ? "TRIAL: " + urlTrialDaysLeft + " days left"
                  : urlTrialDaysLeft === 1
                    ? "TRIAL: this is your last day!"
                    : urlTrialDaysLeft === CONSTANTS.TRIAL_INVALID
                      ? "TRIAL CODE INVALID"
                      : "TRIAL EXPIRED"
                }
              </Typography>
            }

            {/* promotion text */}
            {the350club &&
              <Button onClick={() => window.open("https://www.numerable.io/?utm_source=350club&utm_medium=numapp&utm_campaign=navbarpromotion")}
                variant={portrait ? "promotionTextPortrait" : "promotionTextLandscape"}
              >
                <Tooltip
                  title=<div style={{ whiteSpace: 'pre-line' }}>{infoTip}</div>
                  placement="bottom">
                  <Typography style={{ fontSize: portrait ? 10 : 14 }}>Numerable is available for enterprise use</Typography>
                </Tooltip>
              </Button>
            }

            {!portrait && the350club &&
              <Typography variant={"descriptor"}>
                Regulated financial and board information on UK listed companies
              </Typography>
            }
          </Box>

          {/* RIGHT REGION *}

          {/* user level */}
          {!the350club &&
            <Typography variant="versionId">
              {features.Free && <React.Fragment>{" Free"}</React.Fragment>}
              {features.Trial && <React.Fragment>{"Trial, " + standardTrialDaysLeft + " days left"}</React.Fragment>}
              {features.Standard && <React.Fragment>{"Standard"}</React.Fragment>}
              {features.SubscriptionExpired && <React.Fragment>{"Subscription expired"}</React.Fragment>}
              {features.TrialExpired && <React.Fragment>{"Trial expired"}</React.Fragment>}
              {features.Premium && <React.Fragment>{"Subscribed"}</React.Fragment>}
              {features.Tester && <React.Fragment>{"Subscribed+"}</React.Fragment>}
              {features.Developer && <React.Fragment>{version + " Developer"}</React.Fragment>}
              {features.Deleted && <React.Fragment>{"Deleted"}</React.Fragment>}
            </Typography>
          }

          {/* status messages/icon (&nbsp; prevents "No connection" from being split.) */}
          {network === "DOWN" && <div> No&nbsp;connection to server </div>}
          {/* connection status messages/icon */}
          {/* {network === "DOWN" && <div className="status down">No connection to server</div>} */}

          {network === "PENDING" && (
            <React.Fragment>
              {/* NB: mx = margin-left + margin-right = theme.spacing(2) */}
              <div> <CircularProgress size={30} sx={{ color: "white", mx: 2 }} /></div>
              <div>Reconnecting to server </div>
            </React.Fragment>
          )}

          {/* user menu */}
          {(isLoggedIn || !the350club) && <UserMenu
            changePassword={email => app.changePassword(email)}
            checkboxes={this.props.checkboxes}
            // classes={classes}
            common={this.props.common}
            disconnect={() => app.disconnect()}
            email={email}
            features={features}
            isLoggedIn={isLoggedIn}
            logout={() => {
              if (!the350club && !urlTrial)
                nexus.initData()
              app.logout({ the350club, urlTrial })
            }}
            name={name}
            nexusView={this.props.nexusView}
            page={page}
            radio={this.props.radio}
            the350club={the350club}
            standardTrialDaysLeft={standardTrialDaysLeft}
            urlTrialCode={urlTrialCode}
          />}

          {/* disclosures monitoring config page */}
          {features.DisclosuresMonitoring && <Tooltip title="configure monitoring of regulatory disclosures">
            <Typography
              variant="alertsConfig"
              onClick={() => { history.push(`/${PATH.MONITORING_CONFIG}`) }}
            >Monitoring
            </Typography>
          </Tooltip>}

          {/* alerts configuration page */}
          {features.Favourites && features.NewsAlerts && !the350club && <Tooltip title="configure news alerts ">
            <Typography
              variant="alertsConfig"
              onClick={() => { history.push(`/${PATH.USER_ALERTS_CONFIG}`) }}
            >Alerts
            </Typography>
          </Tooltip>}

          {/* hamburger menu */}
          {
            <HamburgerMenu
              checkboxes={this.props.checkboxes}
              classes={classes}
              common={this.props.common}
              features={features}
              isLoggedIn={isLoggedIn}
              logout={() => {
                if (!the350club && !urlTrial)
                  nexus.initData()
                app.logout({ the350club, urlTrial })
              }}
              lse={this.props.lse}
              news={this.props.news}
              nexusView={this.props.nexusView}
              radio={this.props.radio}
              synopsis={this.props.synopsis}
              the350club={the350club}
              urlTrialCode={urlTrialCode}
            />
          }
          {features.Developer && <React.Fragment>
            {/* ✅ Vertical Divider */}
            <Divider
              orientation="vertical"
              flexItem
              sx={{ mr: 2, width: '2px', height: '60%', alignSelf: 'center', backgroundColor: "white" }}
            />

            {/* data status */}
            {network === "UP" &&
              <MuiTypography
                sx={{
                  // margin: '0 12px',  // adds gap left and right
                  marginRight: '2px',  // right margin only
                  padding: '6px 12px',  // optional: inner padding for nicer look
                  borderRadius: '6px',  // optional: rounded edges
                  color: 'white',
                  backgroundColor: statusBackgroundColor,
                  border: '1px solid white',   // white outline
                }}
                className={classes.AlertsConfigButton}
                onClick={() => { history.push(`/${PATH[BASE.STATUS]}`) }}
              >Status
              </MuiTypography>
            }

            {/* Developer menu */}
            <DeveloperMenu
              aiCosts={this.props.aiCosts}
              checkboxes={this.props.checkboxes}
              classes={classes}
              common={this.props.common}
              features={features}
              isLoggedIn={isLoggedIn}
              logout={() => {
                if (!the350club && !urlTrial)
                  nexus.initData()
                app.logout({ the350club, urlTrial })
              }}
              lse={this.props.lse}
              news={this.props.news}
              nexusView={this.props.nexusView}
              radio={this.props.radio}
              synopsis={this.props.synopsis}
              the350club={the350club}
              urlTrialCode={urlTrialCode}
            />
          </React.Fragment >}

        </Toolbar>
      </AppBar>
    )
  }
}

const mapStateToProps = state => {
  const { app, common, search, synopsis, user } = state
  return {
    version: "v12.0.0",

    // app
    features: app.features,
    page: app.page,

    // appSelectors
    activity: appSelectors.getActivityStatus(state.app),
    isLoggedIn: appSelectors.isLoggedIn(app),
    network: appSelectors.getNetworkStatus(app),
    timeToLogout: appSelectors.getTimeToLogout(app),

    //common
    checkboxes: common.checkboxes,
    currentUrl: common.currentUrl,
    nexusView: common.nexusView,
    radio: common.radio,
    the350club: common.the350club,
    urlTrial: common.urlTrial, // boolean
    urlTrialCode: common.urlTrialCode,
    urlTrialDaysLeft: common.urlTrialDaysLeft,

    // search
    scope: search.scope,
    seed: search.seed,

    synopsisData: synopsis.data,

    // userSelectors
    email: userSelectors.getEmail(user),
    name: userSelectors.getName(user),
    standardTrialDaysLeft: userSelectors.getTrialDaysRemaining(user),
    userId: userSelectors.getId(user),
  }
}

const mapDispatchToProps = dispatch => {
  return {
    aiCosts: bindActionCreators(aiCostsActions, dispatch),
    app: bindActionCreators(appActions, dispatch),
    appSelectors: bindActionCreators(appSelectors, dispatch),
    common: bindActionCreators(commonActions, dispatch),
    lse: bindActionCreators(lseActions, dispatch),
    nexus: bindActionCreators(nexusActions, dispatch),
    news: bindActionCreators(newsActions, dispatch),
    search: bindActionCreators(searchActions, dispatch),
    synopsis: bindActionCreators(synopsisActions, dispatch),
    userSelectors: bindActionCreators(userSelectors, dispatch),
  }
}

// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(withRouter(DashboardNavbar)))

